import Modal from 'react-responsive-modal';
import { Button } from '../../../components/Button';
import styles from './style.module.css';

interface IModalTutorials {
  modalIsOpen: boolean;
  toggleModalIsOpen: () => void;
  tutorial: any;
}

export const ModalTutorials = ({
  modalIsOpen,
  toggleModalIsOpen,
  tutorial,
}: IModalTutorials) => {
  return (
    <Modal
      open={modalIsOpen}
      onClose={toggleModalIsOpen}
      styles={{ modal: { maxWidth: '800px' } }}
    >
      <div className="contents-modal">
        <h1 className="title-modal">{tutorial?.label}</h1>
        <div className="mb-3 mt-3 d-flex flex-column align-items-center">
          <div className="ob-how-to-responsive-video">
            <video
              src={tutorial?.url}
              // poster={videosTutorials[initialIndexTutorial].poster}
              controls
              preload="auto"
            ></video>
          </div>
        </div>
      </div>
      <div className={styles.contentBtn}>
        <Button
          isModal
          text="Fechar"
          type="button"
          color="primary"
          onClick={toggleModalIsOpen}
        />
      </div>
    </Modal>
  );
};
